import { EmployeePanel } from "components";
import { ElementWrapper } from "components/BaseComponents/Flex";

const EmployeeScreen = () => {
  return (
    <>
      <ElementWrapper
        width='872px'
        direction='column'
        justifyContent='flex-start'
        alignItems='flex-start'
        margin='10px auto auto auto'
      >
        <EmployeePanel />
      </ElementWrapper>
    </>
  );
};

export default EmployeeScreen;
